export default __webpack_public_path__ + "static/media/signup.1d989cc4.png";